import { GdsServicesRefundInfoState } from '../types';
import { ActionGdsServicesRefundInfoTypes, SET_GDS_SERVICES_REFUND_INFO } from './actions';

const initialState: GdsServicesRefundInfoState = null;

function gdsServicesRefundInfoReducer(state = initialState, { type, payload }: ActionGdsServicesRefundInfoTypes) {
	switch (type) {
		case SET_GDS_SERVICES_REFUND_INFO:
			return payload;
		default:
			return state;
	}
}

export default gdsServicesRefundInfoReducer;
